import {ActionTypeStrategy} from '@dcp/configurator';

export class FallbackActonTypeStrategy implements ActionTypeStrategy {
  public action(): void {
    // This strategy is not implemented yet
  }
}
